import CirgsInsuranceTable from './CirgsInsuranceTable';

export default CirgsInsuranceTable;
